export const FOB_POINT_CONSTRAINTS = {
    name: { maxLength: 15, label: 'FOB point name' },
};
//# sourceMappingURL=constraints.js.map